// extracted by mini-css-extract-plugin
export default {"break-point-md":"40rem","break-point-lg":"60rem","backdrop":"Backdrop_backdrop__vAHuq"};